import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { UserProvider } from '../services/user.provider';

@Component({
  standalone: false,
  selector: 'lib-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  /**
   * injected services.
   */
  _router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  _authService = inject(AuthenticationService);
  _userProvider = inject(UserProvider);

  /**
   * @inheritdoc
   */
  ngOnInit() {
    const redirectUrl = this.activatedRoute.snapshot.queryParams['redirectTo'];
    const sessionExpired =
      this.activatedRoute.snapshot.queryParams['sessionExpired'];

    this._authService
      .logout()
      .pipe(
        finalize(() => {
          const areLogout = !sessionExpired;
          this._userProvider.clearUserProviderForLogout(areLogout);

          this._router.navigate(['/'], {
            queryParams: {
              sessionExpired: sessionExpired,
              redirectTo: redirectUrl,
            },
            replaceUrl: true,
          });
        }),
      )
      .subscribe({ error: () => undefined });
  }
}
